import familyLaw from "./familyLaw";
import legalCase from "./legalCase";

export default [
  {
    id: "legalCase",
    label: "Legal Case",
    icon: "scalesOfJustice",
    template: legalCase,
    category: "legal",
    creator: "Timeline.App",
    description: "A template for tracking legal cases"
  },
  {
    id: "familyLaw",
    label: "Family Law",
    icon: "familyLaw",
    template: familyLaw,
    category: "legal",
    creator: "Timeline.App",
    description: "A template for tracking legal cases"
  }
  // {
  //   id: "familyCase",
  //   label: "Family Case",
  //   icon: "historical",
  //   template: legalCase
  // },
  // {
  //   id: "criminalCase",
  //   label: "Criminal Case",
  //   icon: "historical",
  //   template: legalCase
  // }
];
